export const SET_INVESTOR_DATA = 'SET_INVESTOR_DATA'

export const setInvestorData = (investorId: number, investorDataHash: string) => (dispatch: any) => {
  dispatch({
    type: SET_INVESTOR_DATA,
    investorId,
    investorDataHash,
  })
}
